// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { headerStyles } from "@insite/content-library/Widgets/AccountSettings/AccountSettingsHeader";
import { css } from "styled-components";

headerStyles.cancelButton = {
    variant: "secondary",
};

headerStyles.buttonSet = {
    css: css`
        justify-content: flex-end;
    `,
    width: [2, 2, 4, 3, 3],
};

headerStyles.titleWrapper = {
    width: [10, 10, 8, 9, 9],
};
